export default __webpack_public_path__ + "static/media/midia_desabonadora.123e1c76.svg";